import React from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipPill } from 'components/Pill';
import getLocalisedDate from 'utils/dates/getLocalisedDate';
import getDaysInbetween from 'utils/getDaysInbetween';
import { getSolidBackgroundShade } from 'utils/ui';
export default function GoalPill(_ref) {
  var goal = _ref.goal;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var goalDueDate = goal.dueDate,
    type = goal.type;
  var description = type === 'complete' ? 'state_due_to_be_completed_on_date' : 'state_due_to_be_opened_on_date';
  var formattedDate = getLocalisedDate({
    date: goalDueDate,
    options: {
      month: 'short',
      year: 'numeric',
      day: 'numeric'
    },
    isInLocalTimezone: true
  });

  // Split off time to ensure we're comparing dates only
  var today = new Date().toISOString().split('T')[0];
  var dueDate = new Date(goalDueDate).toISOString().split('T')[0];
  var daysInbetween = getDaysInbetween(today, dueDate);

  // isOverdue also includes wasDueYesterday ( wasDueYesterday = daysInbetween === 1)
  var isOverdue = daysInbetween >= 1;
  var isDueToday = daysInbetween === 0;
  var isDueTomorrow = daysInbetween === -1;
  var text = t('state_due_on_date', {
    date: formattedDate
  });
  if (isDueToday) {
    text = t('state_due_today');
  } else if (isDueTomorrow) {
    text = t('state_due_tomorrow');
  } else if (isOverdue) {
    text = t('state_due_days_ago', {
      count: daysInbetween
    });
  }
  var colour = isDueToday || isDueTomorrow || isOverdue ? 'negative' : 'calendar';
  return /*#__PURE__*/React.createElement(TooltipPill, {
    icon: "calendar",
    iconColor: colour,
    title: t(description, {
      date: formattedDate
    }),
    background: getSolidBackgroundShade
    // Move to higher z-index to allow the TooltipPill to receive
    // mouse events for the tooltip when placed in a ContentCard
    ,
    z: "raised"
  }, text);
}